import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-24 px-4">
      <div
        className={`max-w-4xl mx-auto bg-gradient-to-br from-[#C8B6FF] to-[#E6D9FF] rounded-3xl px-8 md:px-16 py-14 md:py-20 text-center transition-all duration-700 ${visible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
      >
        <span className="inline-block bg-white/40 text-[#4A2D8A] text-xs font-semibold px-4 py-1.5 rounded-full mb-6">
          Limited Early Access
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-[#1A0A3E] mb-4 leading-tight">
          Be part of the first wave
        </h2>
        <p className="text-[#4A2D8A] text-base md:text-lg mb-3 font-medium">
          2 months free premium for early users.
        </p>
        <p className="text-[#7C55CC]/70 text-sm mb-10 max-w-md mx-auto">
          Join before we go public and lock in your premium access — no credit card required.
        </p>

        <Link
          to="/register"
          className="inline-flex items-center gap-3 bg-gray-900 text-white font-semibold px-8 py-4 rounded-full hover:bg-gray-700 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#C8B6FF]">
            <i className="ri-heart-fill text-gray-900 text-xs"></i>
          </span>
          Join Now
          <i className="ri-arrow-right-line"></i>
        </Link>

        <p className="text-xs text-[#7C55CC]/60 mt-5">No credit card · Cancel anytime</p>
      </div>
    </section>
  );
}
